export const getCustomerAvatar = (files) =>
  files?.find((_) => _.file_sub_type === 'avatar')?.path || '';

export const bytesToSize = (bytes) => {
  const sizes = ['Bytes', 'KiB', 'MiB', 'GiB', 'TiB'];
  if (bytes === 0) return '0 Byte';
  const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
  return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
};

export const getFirstProductSkuImg = (item) =>
  item?.product_skus?.find((_) => _?.files?.length)?.files || [];

export const getFistCategoryLogo = (files) =>
  files?.find((_) => _.file_sub_type === 'logo')?.path || '';

export const separateByFileSubType = (file, fileSubTypes) => {
  return fileSubTypes.reduce((acc, item) => {
    return { ...acc, [item]: file.filter((img) => img.file_sub_type === item) };
  }, {});
};

export const groupFiles = (files) => {
  return Object.values(files).reduce((acc, items) => [...acc, ...items], []);
};
